import React, { useEffect, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import api from '../../services/api';

export type PickedCustomer = { id: number; name: string; phone?: string | null; whatsApp?: string | null };

interface Props {
  value: PickedCustomer | null;
  onChange: (c: PickedCustomer | null) => void;
  label?: string;
}

/** Buscador de clientes con letra y área de toque grandes (modo celular). */
const CustomerPicker: React.FC<Props> = ({ value, onChange, label = 'Cliente' }) => {
  const [options, setOptions] = useState<PickedCustomer[]>([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await api.getCustomers({ page: 1, pageSize: 20, search: search || undefined });
        setOptions((res.customers || []).map((c: any) => ({
          id: c.id,
          name: c.displayName || c.legalName,
          phone: c.phone,
          whatsApp: c.whatsApp,
        })));
      } catch {
        setOptions([]);
      } finally {
        setLoading(false);
      }
    }, 250);
    return () => clearTimeout(t);
  }, [search]);

  return (
    <Autocomplete
      options={options}
      value={value}
      loading={loading}
      getOptionLabel={o => o.name}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      onChange={(_, v) => onChange(v)}
      onInputChange={(_, v, reason) => { if (reason === 'input') setSearch(v); }}
      filterOptions={x => x}
      ListboxProps={{ style: { fontSize: 18 } }}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            sx: { fontSize: 18, minHeight: 56 },
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default CustomerPicker;
